/* eslint-disable import/prefer-default-export */

import { AppState } from 'store';

export const getHasFetchedReadsForTilstandsrapportId = (state: AppState, tilstandsrapportId: string): boolean => {
  return state.user.read.hasFetchedReadsForTilstandsrapportId.indexOf(tilstandsrapportId) > -1;
};

export const getSjekkpunktIsRead = (state: AppState, id: string): boolean => {
  return !!state.user.read.readSjekkpunkter[id];
};
